import { KontentFilterable } from "types/CMS/Unum/filterable";
import { productTaxonomyFilter } from "models/cms/kontent_model/Resolvers/Filters/productTaxomanyFilter";
import { allProductTypes } from "types/enums/Products/Products";
import { navItem } from "types/CMS/Unum/Navbar/navbar";

const navItemsNew: (navItem & KontentFilterable)[] = [
  {
    isFilterable: true,
    productTaxonomy: [],
    id: "1",
    type: "internal",
    label: "Home",
    icon: "HomeLine",
    link: "/homepage",
  },
  {
    isFilterable: true,
    productTaxonomy: ["CIC", "GIP", "GL", "REHAB"],
    id: "2",
    type: "internal",
    label: "Group Protection",
    icon: "BarChartSquare02",
    link: "/claims",
  },
  {
    isFilterable: true,
    productTaxonomy: ["cashPlan"],
    id: "3",
    type: "external",
    label: "Health Plan 360",
    icon: "ShieldPlus",
    link: process.env.REACT_APP_CASHPLAN_REDIRECT_URL ?? "/error",
  },
  {
    isFilterable: true,
    productTaxonomy: [],
    id: "5",
    type: "internal",
    label: "Analytics",
    icon: "PieChart01",
    link: "/analytics",
  },
];

export const navbar = (userProducts: allProductTypes[]): navItem[] => {
  return navItemsNew.filter((item) =>
    productTaxonomyFilter(item, [...userProducts]),
  );
};
